'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Tencent is pleased to support the open source community by making SPA UI available.
* Copyright (C) 2019, a Tencent company. All rights reserved.
*/
// 星星组件

exports.default = function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var value = props.value,
        type = props.type;

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('spaui-rating-star', {
                'spaui-rating-full': type === 'full',
                'spaui-rating-half': type === 'half',
                'spaui-rating-empty': type === 'empty'
            }) },
        _react2.default.createElement('div', { className: 'spaui-rating-first', 'data-halfvalue': value - 0.5, 'data-value': value }),
        _react2.default.createElement('div', { className: 'spaui-rating-second', 'data-halfvalue': value, 'data-value': value })
    );
};